import { createAsyncThunk } from '@reduxjs/toolkit';

import l10n from '../../shared/strings';
import showBatchOperationStartedToast from '../batchOperations/helpers/showBatchOperationStartedToast';
import { OPERATION_TYPES, RESULT } from '../batchOperations/constants';
import handleStoreDisconnectedError, {
  isStoreDisconnectedError,
} from './helpers/handleStoreDisconnectedError';
import { buildBulkPublishingScope } from './helpers/buildDraftMediaPayload';

const strings = l10n.ACTIONS_TOOLBAR.PRODUCTS;

export const publishMastersDirectly = createAsyncThunk(
  'products/publishMastersDirectly',
  async ({
    masterProductIds = [],
    masterVariantIds = [],
    salesChannelIds,
    publishingScope,
    channelName,
  }, {
    extra: {
      sdk, Toast, Logger,
    },
  }) => {
    try {
      const { data } = await sdk.products.publishDirectly({
        masterProductIds,
        salesChannelIds,
        publishingScope: buildBulkPublishingScope(publishingScope),
        ...(masterVariantIds.length && { masterVariantIds }),
      });

      if (data?.batchId) {
        showBatchOperationStartedToast({
          batchId: data.batchId,
          status: data.status || RESULT.queued,
          total: data.total,
          operationType: data.operationType || OPERATION_TYPES.PUBLISH_MASTER_DIRECTLY,
          channelName,
        });
        return data;
      }

      Toast(strings.publishFailed, { type: 'error', autoClose: false });
      throw new Error('Publish directly batch was not started');
    } catch (error) {
      if (isStoreDisconnectedError(error)) {
        handleStoreDisconnectedError({ Toast, error });
      } else {
        Toast(strings.publishFailed, { type: 'error', autoClose: false });
      }
      Logger.error(new Error('Bulk publish directly failed'), { error }, [
        'PublishMastersDirectlyFailed',
        { errorMessage: error?.message || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(publishMastersDirectly.rejected, (state, { error }) => {
    state.error = error?.message || 'Cannot publish selected masters';
  });
};
